import { Tooltip as ReactTooltip } from 'react-tooltip';
import type { ITooltip } from 'react-tooltip';

import styled from '@emotion/styled';

import IconQuestionMark from '@/assets/icons/icon-questionmark.svg';

interface TooltipProps {
  tooltipId: string;
  content?: string;
  size?: 'small' | 'medium';
  place?: ITooltip['place'];
  children?: React.ReactNode;
  openOnClick?: ITooltip['openOnClick'];
}

export function Tooltip({
  tooltipId,
  content,
  size = 'small',
  place = 'top',
  children,
  openOnClick,
}: TooltipProps) {
  return (
    <TooltipContainer>
      <Info size={size} data-tooltip-id={tooltipId} data-tooltip-content={content} />
      <ReactTooltip
        id={tooltipId}
        className="custom-tooltip"
        place={place}
        openOnClick={openOnClick}
      >
        {children}
      </ReactTooltip>
    </TooltipContainer>
  );
}

const TooltipContainer = styled.div`
  .custom-tooltip {
    font-size: 12px !important;
    font-weight: 500 !important;
  }
`;

const Info = styled.div<{ size: 'small' | 'medium' }>`
  width: ${(props) => (props.size === 'small' ? '16px' : '20px')};
  height: ${(props) => (props.size === 'small' ? '16px' : '20px')};
  background-image: url(${IconQuestionMark});
  background-size: 16px 16px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
`;
